export default __webpack_public_path__ + "static/media/i_bus-gen_pp_tagless.bff344df.svg";